module.exports = __webpack_public_path__ + "static/media/image-4.86663114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/image-4.jpg
// module id = 68
// module chunks = 0